import LegalPage, { LegalSection } from "./LegalPage";

const SECTIONS: LegalSection[] = [
  {
    heading: "Information We Collect",
    body: (
      <>
        <p>We collect information needed to provide and improve the Oculera service, including:</p>
        <ul>
          <li>Account details such as name, email address, and clinic or organization.</li>
          <li>Visual field test data and related clinical results generated through the device.</li>
          <li>
            Technical data such as device identifiers, log files, and usage information collected
            automatically when you use our software.
          </li>
          <li>
            Security and audit records created automatically when you sign in or access patient
            records, including your IP address, an approximate location derived from it (country and
            city), the identifier of the device or headset used, and timestamps of the actions
            performed.
          </li>
        </ul>
      </>
    ),
  },
  {
    heading: "Security Logging and Audit Trails",
    body: (
      <>
        <p>
          As a medical software provider, we are required to keep an audit trail of access to
          patient data. When you sign in, view, change, or export patient records, or when a testing
          headset connects to the platform, we automatically record the event together with your IP
          address, an approximate location derived from it at the time of the event (country and
          city), the device identifier, and the outcome of the action.
        </p>
        <p>
          This information is collected for one purpose only: the security and traceability of
          health data, including the detection and investigation of unauthorized access. It is not
          used for marketing, advertising, profiling, or analytics of any kind. Location is resolved
          locally within the region where your data is hosted and is never sent to an external
          service.
        </p>
        <p>
          Audit records are kept in full for 12 months. After 12 months, the IP address is removed
          and location is reduced to country only; the remaining record of who accessed which data
          and when is retained for up to 6 years to meet healthcare record-keeping obligations,
          after which it is deleted. Audit records are stored in the same region as the clinical
          data they relate to.
        </p>
      </>
    ),
  },
  {
    heading: "How We Use Your Information",
    body: (
      <p>
        We use the information to deliver test results, operate and secure the platform, provide
        support, and improve our products. Clinical data is processed only to provide the service to
        you and the patients in your care.
      </p>
    ),
  },
  {
    heading: "Data Security",
    body: (
      <p>
        We apply technical and organizational safeguards designed to protect personal and clinical
        data, including encryption in transit and access controls. No method of transmission or
        storage is completely secure, but we work to protect your information using industry
        practices.
      </p>
    ),
  },
  {
    heading: "Sharing and Disclosure",
    body: (
      <p>
        We do not sell your personal data. We share information only with service providers who help
        us run the platform under appropriate confidentiality obligations, or when required by law.
      </p>
    ),
  },
  {
    heading: "Your Rights",
    body: (
      <p>
        Depending on your location, you may have the right to access, correct, export, or delete
        your personal data. To exercise these rights, contact us using the details below.
      </p>
    ),
  },
  {
    heading: "Changes to This Policy",
    body: (
      <p>
        We may update this policy from time to time. Material changes will be posted on this page
        with an updated revision date.
      </p>
    ),
  },
];

export default function PrivacyPolicy() {
  return (
    <LegalPage
      title="Privacy Policy"
      updated="July 2026"
      intro="This Privacy Policy explains how Oculera collects, uses, and protects information when you use our visual field testing platform and related services."
      sections={SECTIONS}
    />
  );
}
